module.exports = __webpack_public_path__ + "img/7.cf181370.png";